<template>
  <stats-card :header-color="headerColor">
        <template slot="header">
        <div class="data-card card-icon">
            <div class="number">{{getData('renta')}}%</div>
            <div class="number-sub">Rentabilidad</div>
        </div>
        <p class="category"><strong>Margen Bruto:</strong> {{getData('margen_bruto')}} <span class="unit">(USD/ha)</span></p>
        <p class="category"><strong>Margen Neto:</strong> {{getData('margen_neto')}} <span class="unit">(USD/ha)</span></p>
        <p class="category"><strong>Rinde de Equilibrio:</strong> {{getData('rinde_equilibrio')}} <span class="unit">(qq/ha)</span></p>
        <p class="category"><strong>Precio de Equilibrio:</strong> {{getData('precio_equilibrio')}} <span class="unit">(USD/t)</span></p>

        </template>
    </stats-card>
</template>

<script>
import StatsCard from '@/components/Cards/StatsCard'

export default {
  name: 'data-card',
  props: ['data'],
  components: { StatsCard },
  computed: {
    headerColor() {
      return this.getData('renta') > 0 ? 'green' : 'danger';
    }
  },
  methods: {
    getData(index){ return (this.data[index]) ? this.data[index] : 0; }
  }
}
</script>
<style>
.category .unit{
    font-size:10px
}
.card-icon .number{
    font-size: 26px;
    font-weight: bold;
    color: white
}
.card-icon .number-sub{
    color:white;
    font-weight: bold;
    font-size:12px
}
.md-card-stats .md-card-header .category:not([class*="text-"]){
  font-size: 12px;
}
.data-card.card-icon{
  margin-right: 0 !important;
}

@media only screen and (max-width: 1024px) {
  .data-card.card-icon{
    padding: 5px !important;
  }
  .card-icon .number{
    font-size: 20px;
  }
  .md-card-stats .md-card-header .category:not([class*="text-"]){
    font-size: 10px;
  }
}
@media only screen and (max-width: 960px) {
  .data-card.card-icon{
    padding: 15px !important;
  }
  .card-icon .number{
    font-size: 24px;
  }
  .md-card-stats .md-card-header .category:not([class*="text-"]){
    font-size: 14px;
  }
}
@media only screen and (max-width: 768px) {
  .md-card-stats .md-card-header .category:not([class*="text-"]){
    font-size: 12px;
  }
}
@media only screen and (max-width: 768px) {
  .data-card.card-icon{
    padding: 5px !important;
  }
  .card-icon .number{
    font-size: 20px;
  }
}
</style>
